import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router,  ActivatedRoute  } from '@angular/router';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { UserDto } from '@models/user-dto';
import { UserClassesService } from '@services/user-classes.service';
import { UserService } from '@services/user.service';
import { CustomValidators } from '@shared/validators/custom.validators';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'add-to-class',
  templateUrl: './add-to-class.component.html',
  styleUrls: ['./add-to-class.component.css']
})
export class AddToClassComponent implements OnInit {
  model: any = {};
  addToClassForm: FormGroup;
  processing: boolean;
  email: string;
  token: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    public authService: AuthService,
    private alertify: AlertifyService,
    private actRoute: ActivatedRoute,
    private userClassesService: UserClassesService,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

    /*
  ngOnInit() {
    this.createLoginForm();

    this.processing = true;
    if (this.authService.loggedIn()) {
      this.router.navigate(['/home']); 
    }

  }
  */
  ngOnInit() {
    this.createAddToClassForm();
    this.email = this.actRoute.snapshot.params['email'];
    //this.token = this.actRoute.snapshot.params['token'];
  }

  getUrl() {
    return "url('assets/sky8.jpg')";
  }
  //Assigns values to the form
  createAddToClassForm() {
    this.addToClassForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],
      listofnames: ['', [Validators.required]]
    });
  }

  /*
  resetUserPassword() {
    this.model = Object.assign({}, this.changePasswordForm.value);

    this.authService.changePassword(this.model).subscribe(next => {
      //this.alertify.success('Your password had been changed successfully.');
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      //this.alertify.error(error); //  'Failed to loginsss');
    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }
  */
    addToClass() {
      this.model = Object.assign({}, this.addToClassForm.value);
    
      this.authService.addToClass(this.model).subscribe({
        next: (result) => {      
          this.translate.get(["ALERTIFY.USERS_ADDED", "BOOTSTRAP.MODAL.SUCCESS"])
            .subscribe((translations: { [key: string]: string }) => {
              
              this.bootstrap_modal.open({
                modal_header_html: translations['BOOTSTRAP.MODAL.SUCCESS'] || 'Success',
                modal_body_html: translations['ALERTIFY.USERS_ADDED'] || 'Users added successfully',
                modal_color_variant: "success"
              });
            });
        },
        error: (error) => {
          this.alertify.error(error);
        },
        complete: () => {
          // Consider navigating to user management instead of login
          this.router.navigate(['/admin/users']);
        }
      });
    }

  register() {
    this.router.navigate(['/register']);
  }

}
